document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const navWrappers = document.querySelectorAll('.section-subcollection-navigation-wrapper');

        navWrappers.forEach((wrapper) => {
            const slider = wrapper.querySelector('.scroll-container');
            if (!slider) return;

            const $slider = window.jQuery ? window.jQuery(slider) : null;
            const dragArea = slider.querySelector('.mCustomScrollBox') || slider;

            let isDown = false;
            let startX = 0;
            let startScroll = 0;
            let isDragging = false;

            // Check if slider is scrollable
            const isScrollable = () => {
                const container = slider.querySelector('.mCSB_container');

                if (container) {
                    return container.scrollWidth > dragArea.clientWidth;
                }

                return slider.scrollWidth > slider.clientWidth;
            };

            // Update cursor based on slider state
            const updateCursor = () => {
                if (isScrollable()) {
                    dragArea.style.cursor = 'grab';
                } else {
                    dragArea.style.cursor = 'default';
                }
            };

            updateCursor();

            const getCurrentScroll = () => {
                const container = slider.querySelector('.mCSB_container');

                if (container) {
                    const transform = window.getComputedStyle(container).transform;

                    if (transform && transform !== 'none') {
                        const matrix = new DOMMatrix(transform);
                        return Math.abs(matrix.m41);
                    }

                    return Math.abs(parseFloat(container.style.left || 0));
                }

                return slider.scrollLeft;
            };

            dragArea.addEventListener('mousedown', (e) => {
                // Prevent dragging when slider is not scrollable
                if (!isScrollable()) return;

                if (
                    e.target.closest('.mCSB_scrollTools') ||
                    e.target.closest('.scroll-container-actions')
                ) {
                    return;
                }

                isDown = true;
                isDragging = false;

                dragArea.style.cursor = 'grabbing';

                startX = e.pageX;
                startScroll = getCurrentScroll();
            });

            window.addEventListener('mouseup', () => {
                isDown = false;
                updateCursor();
            });

            dragArea.addEventListener('mouseleave', () => {
                isDown = false;
                updateCursor();
            });

            let current = 0;
            let target = 0;
            let raf = null;

            const smoothScroll = () => {
                current += (target - current) * 0.12;

                if ($slider && $slider.hasClass('mCustomScrollbar')) {
                    $slider.mCustomScrollbar('scrollTo', current, {
                        scrollInertia: 0,
                        timeout: 0,
                    });
                } else {
                    slider.scrollLeft = current;
                }

                if (Math.abs(target - current) > 0.5) {
                    raf = requestAnimationFrame(smoothScroll);
                } else {
                    raf = null;
                }
            };

            dragArea.addEventListener('mousemove', (e) => {
                if (!isDown) return;

                e.preventDefault();

                const walk = (e.pageX - startX) * 0.9; // adjust scroll speed here

                if (Math.abs(walk) > 5) {
                    isDragging = true;
                }

                target = startScroll - walk;

                if (target < 0) {
                    target = 0;
                }

                if (!raf) {
                    raf = requestAnimationFrame(smoothScroll);
                }
            });

            slider.querySelectorAll('a').forEach((link) => {
                link.addEventListener('dragstart', (e) => {
                    e.preventDefault();
                });

                link.addEventListener('click', (e) => {
                    if (isDragging) {
                        e.preventDefault();
                    }
                });
            });

            // Re-check cursor on resize
            window.addEventListener('resize', updateCursor);
        });
    }, 300);
});